import type { Locale } from "@/types/nango"

const EN_ORDINAL_RULES = new Intl.PluralRules("en-US", { type: "ordinal" })

const EN_ORDINAL_SUFFIX: Partial<Record<Intl.LDMLPluralRule, string>> = {
  one: "st",
  two: "nd",
  few: "rd",
}

/**
 * A rank as an ordinal ("1st", "2nd"; "1re", "2e"). The French form is the
 * feminine one, as the noun it ranks ("extraction") requires.
 */
export function ordinal(n: number, locale: Locale): string {
  if (locale === "FR") return n === 1 ? "1re" : `${n}e`
  return `${n}${EN_ORDINAL_SUFFIX[EN_ORDINAL_RULES.select(n)] ?? "th"}`
}
